import {
  AlbumCollectionsTable,
  AlbumCollectionsTableGate,
  albumCollectionsTableQuery,
} from '@/entities/album-collections'
import { ROUTES, STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { Button, Space } from 'antd'
import { useUnit } from 'effector-react'
import { NavLink, useNavigate } from 'react-router-dom'

import {
  $collectionsListPageLatestAlbumCollectionsFilters,
  $collectionsListPageLatestAlbumCollectionsPage,
  $collectionsListPageLatestAlbumCollectionsPageSize,
  $collectionsListPageLatestAlbumCollectionsSearch,
  $collectionsListPageLatestAlbumCollectionsSort,
  CollectionsListPageAlbumCollectionsGate,
} from '../../../model/collections-list-album-collections-tab.model'

export const AlbumCollectionsTab = () => {
  const navigate = useNavigate()
  const { data, pending, error } = useUnit(albumCollectionsTableQuery)
  const latestSearch = useUnit($collectionsListPageLatestAlbumCollectionsSearch)
  const latestSort = useUnit($collectionsListPageLatestAlbumCollectionsSort)
  const latestFilters = useUnit(
    $collectionsListPageLatestAlbumCollectionsFilters,
  )
  const latestPage = useUnit($collectionsListPageLatestAlbumCollectionsPage)
  const latestPageSize = useUnit(
    $collectionsListPageLatestAlbumCollectionsPageSize,
  )

  return (
    <>
      <CollectionsListPageAlbumCollectionsGate />
      <AlbumCollectionsTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <AlbumCollectionsTable
            onEdit={(albumCollectionId: string) => {
              void navigate(
                ROUTES.COLLECTIONS.EDIT_ALBUM_COLLECTION.replace(
                  ':id',
                  albumCollectionId,
                ),
              )
            }}
          />
        ) : latestSearch?.length && latestSearch?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одного выпуска"
            content={
              <Space>
                <NavLink to={ROUTES.COLLECTIONS.CREATE_ALBUM_COLLECTION}>
                  <Button>Добавить новый выпуск</Button>
                </NavLink>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
